var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "400px",
    height: "600px",
    viewBox: "0 0 400 600",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Book Placeholder") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E7EE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E4EC",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,0 L397,0 C398.656854,-3.04359188e-16 400,1.34314575 400,3 L400,584 L400,584 L0,584 L0,3 C-2.02906125e-16,1.34314575 1.34314575,3.04359188e-16 3,0 Z",
    id: "Combined-Shape",
    fill: "#F1F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.643484,598.685213 L400,584 L400,584 L0,584 L18.3565161,598.685213 C19.4203944,599.536315 20.7422574,600 22.1046864,600 L377.895314,600 C379.257743,600 380.579606,599.536315 381.643484,598.685213 Z",
    id: "Path-9",
    fill: "url(#linearGradient-1)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E2E4EB",
    opacity: 0.5,
    x: 50,
    y: 154,
    width: 300,
    height: 42,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E2E4EB",
    opacity: 0.5,
    x: 50,
    y: 214,
    width: 300,
    height: 42,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E2E4EB",
    opacity: 0.5,
    x: 50,
    y: 515,
    width: 300,
    height: 26,
    rx: 5
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookPlaceholder);
export default __webpack_public_path__ + "static/media/book-placeholder.0a37bda0348454605e1101c9a1181eec.svg";
export { ForwardRef as ReactComponent };